import { render, staticRenderFns } from "./ApplicantDetail.vue?vue&type=template&id=28040ac4"
import script from "../../controllers/applicant/applicant-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/applicant/applicant-detail.js?vue&type=script&lang=js&external"
import style0 from "./ApplicantDetail.vue?vue&type=style&index=0&id=28040ac4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports